import { createAction } from 'redux-actions';
import { authFetch, authUpload } from '../AuthFetch';

export const changeDownloadMPhotosValue = createAction('CHANGE_DOWNLOAD_MPHOTOS_VALUE');
export const cleanDownloadMPhotosAlert = createAction('CLEAN_DOWNLOAD_MPHOTOS_ALERT');

export const generateMPhotosFile = (bean) => (
  (dispatch) => {
    dispatch({
      type: 'BEFORE_GENERATE_DOWNLOAD_MDATA'
    });
    let url = '/maintenance/mcases/photoFiles';
    authFetch('POST', url, JSON.stringify(bean), (json) => {
      dispatch({
        type: 'AFTER_GENERATE_DOWNLOAD_MDATA',
        payload: json
      });
    });
  }
);

export const generateMCasesFile = (bean) => (
  (dispatch) => {
    dispatch({
      type: 'BEFORE_GENERATE_DOWNLOAD_MDATA'
    });
    let url = '/maintenance/mcases/xlsData';
    authFetch('POST', url, JSON.stringify(bean), (json) => {
      dispatch({
        type: 'AFTER_GENERATE_DOWNLOAD_MDATA',
        payload: json
      });
    });
  }
);

export const generateMCasesFileNtpc = (bean, uploadFileNtpc) => (
  (dispatch) => {
    dispatch({
      type: 'BEFORE_GENERATE_DOWNLOAD_MDATA'
    });
    let url = '/maintenance/mcases/xlsDataNtpc';

    let formData = new FormData();
    formData.append('orderId', bean.get('orderId'));
    formData.append('caseId', bean.get('caseId'));
    formData.append('uploadfile', uploadFileNtpc);

    authUpload('POST', url, formData, (json) => {
      dispatch({
        type: 'AFTER_GENERATE_DOWNLOAD_MDATA',
        payload: json
      });
    });
  }
);
// 建議不再使用
export const generateDiscardList = (bean) => (
  (dispatch) => {
    dispatch({
      type: 'BEFORE_GENERATE_DOWNLOAD_MDATA'
    });
    let url = '/maintenance/mcases/xlsDataDiscard';
    authFetch('POST', url, JSON.stringify(bean), (json) => {
      dispatch({
        type: 'AFTER_GENERATE_DOWNLOAD_MDATA',
        payload: json
      });
    });
  }
);


// WEBPACK FOOTER //
// ./src/actions/downloadMPhotosActions.js